import React from 'react';
import format from 'date-fns/format';
import slugify from 'slugify';

import useQuery from '../utils/use-query';
import useDash from '../utils/dash-api';

const SEX = {
    c: 'Co-Ed',
    f: 'Female',
    m: 'Male',
};

function getGameLabel (type, val) {
    const singular = val === 1;    
    if (type == 6) {
        return singular ? 'Game' : 'Games';
    } else if (type == 1) {
        return singular ? 'Day' : 'Days';
    } else {
        return singular ? 'Session' : 'Sessions';
    }
}

function ResultCard ({
    program_dow,
    description,
    teamdescription,
    facility_id,
    games,
    id,
    name,
    product_id,
    program_type_id,
    sex,
    age_raw,
    start_date,
    end_date,
    starttime,
    endtime,
    event_length,
    price,
    reglink,
}) {

    let the_start_date  = new Date(start_date.replace(' ','T'));
   
    let the_end_date    = new Date(end_date.replace(' ','T'));
  
    // if (format(the_start_date, 'h:mm a') == '12:00 AM') {
    //     starttime = " ";
    //     endtime = " ";
    // }

    var thedescription = teamdescription;

    var readmore_style = {
        display: 'inline'
    };

    if (thedescription.length < 276) {
        readmore_style = {
            display: 'none'
          };
    }

    if (age_raw != "Open" && age_raw != "Youth" && age_raw != "Adult") {
        age_raw = "Ages "+age_raw;
    }

    if (program_dow.length > 4){
        program_dow = program_dow.replace(/,/g, ", ");
        program_dow = program_dow.replace("[sa]", "Sa");
        program_dow = program_dow.replace("[th]", "Th");
        program_dow = program_dow.replace("[m]", "M");
        program_dow = program_dow.replace("[t]", "Tu");
        program_dow = program_dow.replace("[w]", "W");
        program_dow = program_dow.replace("[f]", "F");
        program_dow = program_dow.replace("[s]", "Su");
    } else {
        program_dow = program_dow.replace(/,/g, ", ");
        program_dow = program_dow.replace("[sa]", "Saturday");
        program_dow = program_dow.replace("[th]", "Thursday");
        program_dow = program_dow.replace("[m]", "Monday");
        program_dow = program_dow.replace("[t]", "Tuesday");
        program_dow = program_dow.replace("[w]", "Wednesday");
        program_dow = program_dow.replace("[f]", "Friday");
        program_dow = program_dow.replace("[s]", "Sunday");
    }

    
    // {
    //     program_type_id === window.PROGRAM_TYPES.PROGRAMS &&
    //     <p className="description">
    //         {days_of_week
    //             .filter(d => d)
    //             .map(d => window.DAYS_OF_WEEK[d] + ' Sessions')
    //             .join(', ')
    //         }
    //     </p>
    // }
    // <p className="description">{description}</p>
    var rlink ="";
    var rtitle = "";
    var bool;
    if (reglink === 'waitlist') {
        rtitle = "Waitlist";
        //reglink = 'https://apps.dashplatform.com/ice/dash/index.php?Action=signupSwitch/index&FacilityID='+facility_id+'&teamID='+id+'&company=canlan';
        //reglink = 'https://apps.dashplatform.com/pr/dash/x/#/online/canlan/group/register/'+id;
        reglink = 'https://apps.daysmartrecreation.com/dash/x/canlan/group/register/'+id+'?time='+Math.random();

        rlink = 'href="'+reglink+'"';
        bool = true;
    } else if (reglink === 'Sold out') {
        rtitle = "Sold Out";
        rlink = "";
        bool = false;
    } else if (reglink === 'Call to register') {
        rtitle = "Call to register";
        rlink = "";
        bool = false;
    } else {
        rlink = 'href="'+reglink+'"';
        rtitle = "Get Started";
        bool = true;
    }
    if(window.PROGRAM_TYPES.DROPINS) {
        rtitle = "Get Started";
    }
//<p>{format(starttime, 'h:mm a')} - {format(endtime, 'h:mm a')}</p>
        return (
            <div className="card activity-result-card">
                
                <div className="card-header">
                    {/* <div className="mobile-header-row">
                        <a {...(bool ? {href:reglink} : {})} rel="noopener" title={rtitle} data-value={price.toFixed(0)} target="_blank">
                            <p className="price"><span class="ageraw">{age_raw} | </span>${price.toFixed(2)}</p>
                            <h3>{name}</h3>
                        </a>
                    </div> */}
                    {/* <a {...(bool ? {href:reglink} : {})} rel="noopener" title={rtitle} data-value={price.toFixed(0)} target="_blank"> */}
                        <div className="row rdate">
                            <img src={`${window.ASSET_PATH}/images/icons/date.svg?v=1`} />
                            <p>
                                {
                                  the_start_date.toString() !== "Invalid Date" ? format(the_start_date, 'LLL d, yyyy') : ""
                                } 
                                -
                                {
                                  the_end_date.toString() !== "Invalid Date" ? format(the_end_date, 'LLL d, yyyy') : ""
                                }
                            </p>
                        </div>
                        {program_dow != '[N/A]' &&
                            <div className="row rdow">
                                <img src={`${window.ASSET_PATH}/images/icons/date.svg?v=1`} />
                                <p>{program_dow}</p>
                            </div>
                        }
                        {the_start_date.toString() !== "Invalid Date" && (format(the_start_date, 'h:mm a') != '12:00 AM') &&
                            <div className="row rtime">
                                <img src={`${window.ASSET_PATH}/images/icons/time.svg?v=1`} />
                                <p>{starttime} - {endtime}</p>
                            </div>
                        }
                        <div className="row rgames">
                            <img src={`${window.ASSET_PATH}/images/icons/games.svg?v=1`} />
                            <p>{games} {getGameLabel(program_type_id, games)}</p>
                        </div>
                        <div className="row rgender">
                            <img src={`${window.ASSET_PATH}/images/icons/${slugify(SEX[sex].replace("-",""), { lower: true })}.svg?v=1`} />
                            <p>{SEX[sex]}</p>
                        </div>
                    {/* </a> */}
                    
                        <div id="location-desktop" className="row rlocation">
                            <img src={`${window.ASSET_PATH}/images/icons/map-marker-w.svg?v=1`} />
                            <p>                   
                                <a href={window.FACILITIES[facility_id].url} target="_blank" title={window.FACILITIES[facility_id].name}>
                                    {window.FACILITIES[facility_id].name}
                                </a>
                            </p>
                        </div>
                    
                </div>
                <div className="card-body">
                    <a {...(bool ? {href:reglink} : {})} rel="noopener" title={rtitle} data-value={price.toFixed(0)} target="_blank">
                        <p className="price">${price.toFixed(2)}</p>
                        <h3>{name}</h3>
                        <p class="ageraw"><img src={`${window.ASSET_PATH}/images/icons/ageraw.svg`} />{age_raw}</p>
                        <div id={id} class="description hshort" dangerouslySetInnerHTML={{__html: thedescription}} />
                    </a>
                    <div class="rm-div">
                        <a id={'rm-'+id} style={readmore_style} class="read-more-link" href={'javascript:expandme('+id+',"showmore");'}>Read More</a>
                        <a id={'rl-'+id} class="read-less-link" href={'javascript:expandme('+id+',"showless");'}>Read Less</a>
                    </div>
                    <a className="btn btn-slide" {...(bool ? {href:reglink} : {})} rel="noopener" title={rtitle} data-value={price.toFixed(0)} target="_blank">{rtitle}</a>
                    <a  id="location-mobile"
                        className="location"
                        href={window.FACILITIES[facility_id].url}
                        target="_blank"
                        title={window.FACILITIES[facility_id].name}
                    >
                        {/* <img src={`${window.ASSET_PATH}/images/icons/map-marker.svg`} /> */}
                        {window.FACILITIES[facility_id].name}
                    </a>
                </div>
            </div>
        );

    
    
   
}

export default function () {
    const [ filters, ] = useQuery();

    //const results = useDash(filters);
    
    const results = useDash(filters, window.PROGRAM_META);
    return (
        <section className="result-cards">
            <div className="container">
                {/* <div className="result-header">
                    <p>Results found: {results.length}</p>
                </div> */}
                {results.map(({ id,attributes,relationships }) =>
                    <ResultCard
                        id={id}
                        type={filters.type}
                        {...attributes}
                        {...relationships}
                    />
                )}
            </div>
        </section>
    );
}
